import type { Maybe } from '@adornis/base/utilTypes.js';
import { configRegistry } from '@adornis/bh-matching-config/entities/global-config.js';
import { RXController } from '@adornis/chemistry/controllers/RXController.js';
import { css } from '@adornis/chemistry/directives/css.js';
import { XNativeDialog } from '@adornis/dialog/x-native-dialog.js';
import { html, nothing } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import type { DefaultMenteeUser, DefaultMentorUser } from '../entities/buddy-user.js';
import { getMenteeUserClass, getMentorUserClass } from '../user-class.js';

@customElement('matching-form-dialog')
export class MatchingFormDialog extends XNativeDialog<void> {
  @property({ attribute: false }) userEntity = new RXController<Maybe<DefaultMenteeUser | DefaultMentorUser>>(
    this,
    null,
  );

  static override get element_name() {
    return 'matching-form-dialog';
  }

  override content() {
    const userEntity = this.userEntity.value;
    if (!userEntity) return nothing;

    return html`
      <x-flex space="md" ${css({ maxHeight: '90vh', minWidth: '40vw' })}>
        ${this._form()}
        <x-flex padding="md" horizontal start>
          <x-button
            mode="outline"
            icon="delete"
            tone="error"
            @click=${async () => {
              XNativeDialog.guard(() => userEntity.remove(), { hasToConfirm: true }).then(
                result => result && this.close(),
              );
            }}
          >
            Löschen
          </x-button>
        </x-flex>
      </x-flex>
    `;
  }

  private _form() {
    const userEntity = this.userEntity.value;
    if (!userEntity) return nothing;
    const isMenteeClass = userEntity._class === getMenteeUserClass()._class;

    console.log({
      userEntity,
      customFieldMapping: isMenteeClass
        ? configRegistry.menteeCustomFieldMapping
        : configRegistry.mentorCustomFieldMapping,
    });
    return html`
      <buddy-page-signup
        .userClass=${isMenteeClass ? getMenteeUserClass() : getMentorUserClass()}
        page-title=""
        .userEntity=${userEntity}
        .customFieldMapping=${isMenteeClass
          ? configRegistry.menteeCustomFieldMapping
          : configRegistry.mentorCustomFieldMapping}
        @user-updated=${() => this.close()}
      ></buddy-page-signup>
    `;
  }

  static showDialog(userEntity: DefaultMenteeUser | DefaultMentorUser) {
    return this.showPopup<void>({
      props: {
        userEntity,
      },
    });
  }
}
